export function setBranchHeaderDetails(headerDetails) {
    return function ( dispatch ) {
        dispatch({type: 'SET-BRANCH-HEADER-DETAILS',headerDetails});
    }
}